import { StyleSheet } from 'react-native'
import { Theme } from '@theme'

export const getAddConversationStyles = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: theme.colors.background,
    },
    
    // Styles pour la liste des contacts
    contactsList: {
      flex: 1,
    },
    
    contactsContent: {
      paddingVertical: 8,
    },
    
    contactItem: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: theme.colors.white,
      paddingHorizontal: 16,
      paddingVertical: 12,
      position: 'relative',
    },
    
    contactAvatar: {
      width: 40,
      height: 40,
      borderRadius: 20,
      marginRight: 12,
    },
    
    contactInfo: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
    },
    
    contactDetails: {
      flex: 1,
    },
    
    contactName: {
      fontSize: 16,
      fontWeight: '500',
      color: theme.colors.text,
      marginBottom: 4,
    },
    
    contactPhone: {
      fontSize: 14,
      color: theme.colors.grey50,
    },
    
    selectedContactItem: {
      backgroundColor: theme.colors.primary + '10',
    },
    
    checkIcon: {
      width: 24,
      height: 24,
      borderRadius: 12,
      backgroundColor: theme.colors.primary,
      alignItems: 'center',
      justifyContent: 'center',
    },
    
    // Système de sélection existant
    checkbox: {
      width: 20,
      height: 20,
      borderRadius: 10,
      borderWidth: 2,
      borderColor: theme.colors.lightGrey,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.colors.white,
      marginRight: 12,
    },
    
    checkboxSelected: {
      backgroundColor: theme.colors.primary,
      borderColor: theme.colors.primary,
    },
    
    selectionBar: {
      position: 'absolute',
      right: 0,
      top: 0,
      bottom: 0,
      width: 6,
      borderRadius: 3,
      backgroundColor: theme.colors.white,
    },
    
    selectionBarActive: {
      backgroundColor: theme.colors.primary,
    },

    // Styles pour le bouton continuer
    continueContainer: {
      paddingHorizontal: 16,
      paddingVertical: 12,
      backgroundColor: theme.colors.white,
      borderTopWidth: 1,
      borderTopColor: theme.colors.border,
    },
  
    continueButton: {
      paddingVertical: 12,
      paddingHorizontal: 24,
      borderRadius: 25,
      alignItems: 'center',
      justifyContent: 'center',
    },
    
    continueButtonText: {
      color: theme.colors.white,
      fontSize: 16,
    },

    // Styles pour l'input (copiés de Conversation)
    inputContainer: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      padding: theme.spacing.md,
      backgroundColor: theme.colors.white,
      borderTopWidth: 1,
      borderTopColor: theme.colors.border,
    },
    
    inputWrapper: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'flex-end',
      backgroundColor: theme.colors.grey,
      borderRadius: 25,
      paddingHorizontal: theme.spacing.xs,
      paddingVertical: theme.spacing.xs,
      marginRight: theme.spacing.sm,
      minHeight: 40,
    },
    
    textInput: {
      flex: 1,
      fontSize: theme.fontSize.medium,
      paddingVertical: (40 - theme.fontSize.medium)/3,
      color: theme.colors.secondary,
      maxHeight: 150,
      marginRight: 12,
      paddingHorizontal: theme.spacing.md,
    },
    
    sendButton: {
      width: 40,
      height: 40,
      borderRadius: 20,
      backgroundColor: theme.colors.primary,
      alignItems: 'center',
      justifyContent: 'center',
    },
    
    imageButton: {
      width: 50,
      height: 50,
      borderRadius: 50,
      alignItems: 'center',
      justifyContent: 'center',
    },
    // Système de tabs comme dans Calendar
    tabContainer: {
      flexDirection: 'row',
      paddingHorizontal: 0,
      marginBottom: 0,
      backgroundColor: theme.colors.white,
      borderBottomWidth: 1,
      borderBottomColor: theme.colors.lightGrey,
    },
    tabButton: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      paddingVertical: theme.spacing.lg,
      position: 'relative',
    },
    activeTabButton: {
      backgroundColor: 'transparent',
    },
    activeTabIndicator: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: 2,
    },
    tabText: {
      fontSize: theme.fontSize.medium,
      fontWeight: '500',
      color: theme.colors.greyBlue,
      marginLeft: theme.spacing.sm,
    },
    sectionTitle: {
      fontSize: theme.fontSize.small,
      color: theme.colors.greyBlue,
      fontWeight: '500',
      paddingHorizontal: theme.spacing.lg,
      paddingVertical: theme.spacing.md,
      textTransform: 'uppercase',
    },
    
    tab: {
      flex: 1,
      paddingVertical: theme.spacing.md,
      alignItems: 'center',
      borderBottomWidth: 2,
      borderBottomColor: 'transparent',
    },
    
    activeTab: {
      borderBottomColor: theme.colors.primary,
    },
    
    activeTabText: {
      color: theme.colors.primary,
      fontWeight: '600',
    },
    
    messageInputContainer: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      paddingHorizontal: theme.spacing.lg,
      paddingVertical: theme.spacing.md,
      backgroundColor: theme.colors.white,
      borderTopWidth: 1,
      borderTopColor: theme.colors.grey20,
    },
    
    messageInputWrapper: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: theme.colors.grey20,
      borderRadius: 25,
      paddingHorizontal: theme.spacing.md,
      paddingVertical: theme.spacing.sm,
      marginRight: theme.spacing.sm,
      minHeight: 40,
    },
    
    messageInput: {
      flex: 1,
      fontSize: 16,
      color: theme.colors.text,
      maxHeight: 100,
      paddingVertical: 0,
      marginRight: theme.spacing.sm,
    },
  }) 